import ApiConnector from "../connector";

class ProjectsActions {
  get = async (params) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/projects/`, { params });
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  getOne = async (slug) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/projects/${slug}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  create = async (payload) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.post(`/projects/`, payload);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  update = async (payload) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.patch(`/projects/${payload.slug}/`, payload);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  delete = async (slug) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.delete(`/projects/${slug}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
}

export default new ProjectsActions();
